import { configureStore } from '@reduxjs/toolkit'
import rootReducer from "./reducers/RootReducer"

// Custom middleware to replace redux-debounced
const debounceMiddleware = () => (next) => (action) => {
  if (action.meta?.debounce) {
    const { delay = 0, key = action.type } = action.meta.debounce
    clearTimeout(debounceMiddleware.timers[key])
    debounceMiddleware.timers[key] = setTimeout(() => {
      next(action)
    }, delay)
  } else {
    next(action)
  }
}
debounceMiddleware.timers = {}

// Configure store with middleware
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Enable if you need to work with non-serializable values
      serializableCheck: {
        // Ignore certain paths in the state
        ignoredActions: ['some-action-type'],
        ignoredPaths: ['some.path']
      },
    }).concat(debounceMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
})

export { store }